<template>
  <div class="navCom_wrapper">
    <div class="PC_wrap">
      <el-row style="display: flex; align-items: center">
        <el-col :span="15">
          <div class="logo_nav">
            <img
              src="../assets/nav/tdyh_logo.png"
              alt=""
              style="margin-right: 25px"
            />
            <img src="../assets/nav/logo_home.png" alt="" />
          </div>
        </el-col>
        <el-col :span="9">
          <div class="a_link_nav">
            <el-row style="display: flex; align-items: center">
              <el-col :span="18">
                <div class="link_list">
                  <el-menu
                    :default-active="activeIndex"
                    class="link_list"
                    mode="horizontal"
                    @select="handleSelect"
                    style="background: none"
                    active-text-color="#fc4f1a"
                    router
                  >
                    <el-menu-item index="/home" class="link_list_item"
                      >首页</el-menu-item
                    >
                    <el-menu-item index="/about" class="link_list_item"
                      >关于我们</el-menu-item
                    >
                    <el-submenu index="3">
                      <template slot="title">
                        <span class="link_list_item">产品中心</span>
                      </template>
                      <el-menu-item
                        style="
                          padding: 20px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        index="/unattended"
                        >无人值守危废库</el-menu-item
                      >
                      <el-menu-item
                        style="
                          padding: 20px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        index="/wasteTerminal"
                        >危废终端设备</el-menu-item
                      >
                      <el-menu-item
                        style="
                          padding: 20px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        index="/digitalize"
                        >危废收集数字化管理系统</el-menu-item
                      >
                      <el-menu-item
                        style="
                          padding: 20px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        index="/intelligent"
                        >固体废物全过程智慧化管理平台</el-menu-item
                      >
                    </el-submenu>
                    <el-menu-item index="/news" class="link_list_item"
                      >资讯中心</el-menu-item
                    >
                    <el-menu-item index="/contact" class="link_list_item"
                      >联系我们</el-menu-item
                    >
                  </el-menu>
                </div>
              </el-col>
              <el-col :span="6" v-if="false">
                <div class="link_search">
                  <img src="../assets/nav/search_icon.png" alt="" />
                  <input type="text" placeholder="搜索..." />
                </div>
              </el-col>
              <el-col :span="6">
                <div class="link_language" v-if="false">
                  <img
                    class="net_icon"
                    src="../assets/nav/net_icon.png"
                    alt=""
                  />
                  中文
                  <img
                    class="change_icon"
                    src="../assets/nav/change_icon.png"
                    alt=""
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="phone_wrap">
      <div class="logo_nav">
        <img
          src="../assets/nav/tdyh_logo.png"
          alt=""
          style="margin-right: 10px"
        />
        <img src="../assets/nav/logo_home.png" alt="" />
      </div>
      <div class="a_link_nav">
        <el-menu
          default-active="1-4-1"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          active-text-color="#fc4f1a"
          style="background: none"
          router
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-menu" style="color: #fc4f1a"></i>
            </template>
            <el-menu-item index="/home" class="link_list_item"
              >首页</el-menu-item
            >
            <el-menu-item index="/about" class="link_list_item"
              >关于我们</el-menu-item
            >
            <el-submenu index="3">
              <template slot="title">
                <span class="link_list_item">产品中心</span>
              </template>
              <el-menu-item index="/unattended">无人值守危废库</el-menu-item>
              <el-menu-item index="/wasteTerminal">危废终端设备</el-menu-item>
              <el-menu-item index="/digitalize"
                >危废收集数字化管理系统</el-menu-item
              >
              <el-menu-item index="/intelligent"
                >固体废物全过程智慧化管理平台</el-menu-item
              >
            </el-submenu>
            <el-menu-item index="/news" class="link_list_item"
              >资讯中心</el-menu-item
            >
            <el-menu-item index="/contact" class="link_list_item"
              >联系我们</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCollapse: false,
      activeIndex: "/home",
      indexKey: "/home",
    };
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path; // 在路由切换时更新激活状态
      this.indexKey = to.path;
      console.log(to.path);
      if (to.path == "/home") {
        this.$emit("headerHeight", { heigth: "850px", indexKey: to.path });
      } else if (to.path == "/contact") {
        this.$emit("headerHeight", { heigth: "555px", indexKey: to.path });
      } else if (to.path == "/news" || to.path == "/details") {
        this.$emit("headerHeight", { heigth: "555px", indexKey: to.path });
      } else {
        this.$emit("headerHeight", { heigth: "640px", indexKey: to.path });
      }
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      // this.indexKey = key
      // if (key == '/home') {
      //     this.$emit('headerHeight', { heigth: '850px', indexKey: this.indexKey });
      // } else if (key == '/contact') {
      //     this.$emit('headerHeight', { heigth: '555px', indexKey: this.indexKey })
      // } else if (key == '/news') {
      //     this.$emit('headerHeight', { heigth: '555px', indexKey: this.indexKey })
      // } else {
      //     this.$emit('headerHeight', { heigth: '640px', indexKey: this.indexKey })
      // }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  max-width: 400px;
  min-height: 50px;
}
</style>
<style lang="less" scoped>
// PC端
@media screen and (min-width: 769px) {
  .navCom_wrapper {
    width: 100%;

    // background-color: rgb(107, 208, 233);
    .phone_wrap {
      display: none;
    }

    .PC_wrap {
      display: block;
    }

    .logo_nav {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 164px;
      height: 41px;
      margin-left: 221px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .a_link_nav {
      .link_list {
        display: flex;

        .link_list_item {
          font-size: 17px;
          color: #ffffff;
        }
      }

      .link_search {
        display: flex;
        align-items: center;
        border-right: 1px solid #f0f0f0;
        border-left: 1px solid #f0f0f0;
        margin-left: 43px;
        margin-right: 29px;
        padding-left: 30px;
        padding-right: 10px;
        box-sizing: border-box;

        img {
          width: 17px;
          height: 17px;
          margin-right: 5px;
        }

        input {
          width: 70%;
          padding: 0 10px;
          border: none;
          outline: none;
          background: none;
          color: #f0f0f0;
        }
      }
    }

    .link_language {
      display: flex;
      align-items: center;
      color: #f0f0f0;
      cursor: pointer;

      .net_icon {
        margin-left: 29px;
        margin-right: 15px;
        width: 19px;
        height: 19px;
      }

      .change_icon {
        margin-left: 23px;
        width: 14px;
        height: 12px;
      }
    }
  }

  /deep/.el-menu-item:hover,
  .el-submenu:hover,
  .el-submenu__title:hover {
    background-color: rgba(0, 0, 0, 0.3) !important;
    /* 将颜色值替换为您想要的颜色 */
  }

  /deep/.el-menu--popup .el-submenu__title:hover,
  .el-menu--popup .el-menu-item:hover {
    background-color: rgba(0, 0, 0, 0.3) !important;
  }

  /deep/.el-menu.el-menu--horizontal {
    border-bottom: solid 0 #e6e6e6;
  }
}

// 移动端
@media screen and (max-width: 768px) {
  .navCom_wrapper {
    width: 100%;
    position: relative;

    // background-color: rgb(107, 208, 233);
    .PC_wrap {
      display: none;
    }

    .phone_wrap {
      display: block;
    }

    .logo_nav {
      display: flex;
      // justify-content: flex-end;

      margin-left: 20px;

      img {
        width: 100px;
        // height: 21px;
      }
    }

    .a_link_nav {
      position: absolute;
      top: 50px;
      right: 10px;
    }

    /deep/.el-menu {
      border-right: solid 0px #e6e6e6;
      list-style: none;
      position: relative;
      margin: 0;
      padding-left: 0;
      background-color: #fff;
    }
  }
}
</style>
